module.exports = __webpack_public_path__ + "static/media/azure.a40e22ed.svg";